export default __webpack_public_path__ + "static/media/agency-lg-3.63e5cff0.webp";